export default __webpack_public_path__ + "static/banner-tampons-3-2f2feef069cf0e9406867560344aab2f.png";